import React, {forwardRef} from 'react';
import Fade from '@material-ui/core/Fade';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Menu from '@material-ui/core/Menu';
import Settings from '@material-ui/icons/Settings';

const AppSidebarAdminLinksMenu = forwardRef((props, ref) => {
    const {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'className' does not exist on type '{ chi... Remove this comment to see the full error message
        className,
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'handleClickListItem' does not exist on t... Remove this comment to see the full error message
        handleClickListItem,
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'anchorEl' does not exist on type '{ chil... Remove this comment to see the full error message
        anchorEl,
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'isOpen' does not exist on type '{ childr... Remove this comment to see the full error message
        isOpen,
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'onClose' does not exist on type '{ child... Remove this comment to see the full error message
        onClose,
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'links' does not exist on type '{ childre... Remove this comment to see the full error message
        links,
    } = props;
    
    return (
        <>
            <ListItem
                button
                // @ts-expect-error ts-migrate(2769) FIXME: Type 'unknown' is not assignable to type 'HTMLDivE... Remove this comment to see the full error message
                ref={ref}
                aria-haspopup="true"
                aria-controls="lock-menu"
                aria-label="admin-links"
                onClick={handleClickListItem}
                className={className}
            >
                <ListItemIcon>
                    <Settings />
                </ListItemIcon>
                <ListItemText
                    primary="Admin"
                />
            </ListItem>
            <Menu
                id="lock-menu"
                anchorEl={anchorEl}
                keepMounted
                open={isOpen}
                onClose={onClose}
                TransitionComponent={Fade}
            >
                {links}
            </Menu>
        </>
    );
});

export default AppSidebarAdminLinksMenu;
